import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import { ProposalRecipients } from "../types";
import { RECIPIENT_ROLES, recipientsWithRole } from "./recipients";

interface Props {
  recipients: ProposalRecipients;
  onEdit: () => void;
  // Locked while another action is running.
  disabled?: boolean;
}

export const RecipientsCard: React.FC<Props> = ({
  recipients,
  onEdit,
  disabled = false
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4" data-test="proposal-recipients-card">
      <div className="flex items-center justify-between gap-2">
        <Text variant="smSubtitle" id="proposal-recipients-title">
          {t("contracts.proposals.editor.recipients.title")}
        </Text>
        <Button
          variant="tertiary"
          onClick={onEdit}
          disabled={disabled}
          data-test="proposal-recipients-edit"
        >
          {t("contracts.proposals.editor.recipients.editLabel")}
        </Button>
      </div>
      {recipients.list.length === 0 ? (
        <Text variant="bodyTertiary" className="px-1">
          {t("contracts.proposals.editor.recipients.empty")}
        </Text>
      ) : (
        RECIPIENT_ROLES.map((role) => {
          const group = recipientsWithRole(recipients, role);
          if (group.length === 0) return null;
          return (
            <div
              key={role}
              className="flex flex-col gap-3 px-1"
              data-test={`proposal-recipients-${role}`}
            >
              <Text variant="smBodySecondary">
                {t(`contracts.proposals.recipients.role.${role}`)}
              </Text>
              <ul className="flex flex-col gap-3 px-1">
                {group.map((recipient) => (
                  <li key={recipient.key} className="min-w-0">
                    <Text
                      variant="body"
                      className="truncate"
                      hasTruncatedTooltip
                    >
                      {recipient.name}
                    </Text>
                  </li>
                ))}
              </ul>
            </div>
          );
        })
      )}
    </div>
  );
};
